import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../../services/api.service'
import { ButtonComponent } from '@components/button/button.component'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { HomeLinksService } from '../../../services/home-links.service'



interface LeadStats {
  newCustomers: number;
  unconfirmed: number;
  oppInProgress: number;
  almostComplete: number;
  total: number;
}
@Component({
    selector: 'app-leads-block',
    templateUrl: './leads-block.component.html',
    imports: [ButtonComponent, CommonModule, TranslateModule],
    standalone: true,
    styleUrl: './leads-block.component.scss',
})
export class LeadsBlock implements OnInit {
    userInfo: UserInfo
    leadsStats: LeadStats

    constructor(
        private api: ApiService,
        private homeLinksService: HomeLinksService
    ) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
            if(this.userInfo && this.userInfo.id){
                this.api.getLeadStats().subscribe((stats) => {
                    this.leadsStats = stats
                })
            }
        })
    }
    goToLeads() {
        this.homeLinksService.goToLeads()
    }
}
